import backgroundImg from "@/assets/background.webp"
import FrostedGlass from "@/components/FrostedGlass"
import PageBackground from "@/components/PageBackground"
import { useAppConfig } from "@/stores/appConfigStore"
import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import BasicPage from "../BasicPage"
import LoginButton from "./LoginButton"

const contentStyles = css`
	display: flex;
	flex-direction: column;
	width: 34rem;

	font-size: 1.125rem;
	h1 {
		font-size: 1.5rem;
		font-weight: 600;
		margin: 0;
		color: #444;
	}
	hr {
		border-color: black;
	}
	button {
		margin-top: 2rem;
		width: 100%;
		font-size: 1.125rem;
	}
`

const App: ReactiveComponent = () => {
	const config = useAppConfig()

	return () => (
		<BasicPage title={config.appName} noPadding noNav plain>
			<PageBackground imageUrl={backgroundImg}>
				<FrostedGlass class={contentStyles}>
					<h1>{config.appName}</h1>
					<hr />
					<p>Welcome to the Guernsey Coastguard SARLog.</p>
					<p>Please click the button below to log in to the application.</p>
					<div class="flex justify-center">
						<LoginButton />
					</div>
				</FrostedGlass>
			</PageBackground>
		</BasicPage>
	)
}

export default defineComponent(App)
